import React, { useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import useStyles from '../Locations/style';
import { useGetSublocationByIdQuery } from '../../../services/Sublocation/SublocationService';
import BREADCRUMB_NAMES from '../../../constants/breadcrumbNames';
import { routeConstants } from '../../../constants/routeConstants';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { Box, Chip, Container, Stack, Typography } from '@mui/material';
import { Breadcrumbs } from '../../../components/shared';
import { NavigateNext } from '@mui/icons-material';
import EditRemitUpdateView from './EditRemitUpdateView';

const EditRemit = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const classes = useStyles();
  const {
    currentData: subLocationDetailsResponse,
    isLoading,
    isFetching,
  } = useGetSublocationByIdQuery({ id: Number(id) });
  const { data: detailsResponse } = subLocationDetailsResponse ?? {};
  const {
    LOCATION: { LOCATION, LOCATION_DETAIL, SUB_LOCATION_DETAIL, EDIT_REMIT },
  } = BREADCRUMB_NAMES;
  const breadcrumbData = useMemo(
    () => [
      { text: LOCATION, redirection: `${routeConstants.LOCATION_ROUTE}` },
      {
        text: LOCATION_DETAIL,
        redirection: `${routeConstants.LOCATION_ROUTE}/${Number(searchParams.get('locationId'))}`,
      },
      {
        text: SUB_LOCATION_DETAIL,
        redirection: `${routeConstants.SUBLOCATION_ROUTE}/${Number(id)}?locationId=${Number(
          searchParams.get('locationId'),
        )}`,
      },
      { text: EDIT_REMIT },
    ],
    [id],
  );
  if (isLoading || isFetching) {
    return <LoadingSpinner containerHeight={400} />;
  }
  return (
    <Container maxWidth="xl" disableGutters className={classes.root}>
      <Box className={classes.breadcrumbContainer}>
        <Breadcrumbs
          icon={<NavigateNext fontSize="medium" />}
          variant="body2"
          underline="hover"
          data={breadcrumbData}
        />
      </Box>
      <Box my={4}>
        <Stack direction={'row'} alignItems="center" spacing={2}>
          <Typography variant="h1">{detailsResponse?.name}</Typography>
          <Chip
            label={detailsResponse?.status ? 'Active' : 'Inactive'}
            color={detailsResponse?.status ? 'success' : 'error'}
            variant="outlined"
          />
        </Stack>
      </Box>
      <Box>
        <EditRemitUpdateView subLocationDetails={detailsResponse} />
      </Box>
    </Container>
  );
};

export default EditRemit;
